import React, { useContext, useState, useEffect, useRef } from "react"
import PropTypes from "prop-types"
import { Field, Form, Formik } from "formik"
import { NumberInput } from "../forms"
import { Button, ErrorMessage } from "../styled"
import { validatePhone } from "../../utils/Helpers"
import { promoCodeCompanyLookup, companyLookupFactory } from "../../utils/LookupHelper"
import { AppContext } from "../context/AppContext"
import { isOnPage } from "../../utils/Helpers"
import { v4 as uuidv4 } from 'uuid'




export const CrossCompanyPhoneCheck = ({ initialValues, promoCode, checkStatusMode, buttons, phoneInputClass, fromYoutubeComponent}) => {
  const {dispatch, state} = useContext(AppContext)
  const [providerNotFound, setProviderNotFound] = useState(false)
  const [providerNotFoundMessage, setProviderNotFoundMessage] = useState("")
  const [miscError, setMiscError] = useState('')
  const [provideText, setProvideText] = useState()
  const phoneNumberInputContainer = useRef();
  const phoneNumberId = `phoneNumber${uuidv4()}`

  const companyLookupFn = promoCode ? promoCodeCompanyLookup : companyLookupFactory

  useEffect(() => {
    if(state.miscError.ooma && state.miscError.ooma.length)
      setMiscError(state.miscError.ooma)
      sprintOrTmoInputText();
  }, [state.miscError])


  const focusOnPhoneNumber = (phno) => {
    if ((phno.length >= 0 && phno.length < 10) && fromYoutubeComponent) {
      phoneNumberInputContainer.current.querySelector("input").focus()
    }
   
  }
  const sprintOrTmoInputText = ()=>{
    if(isOnPage('ooma') ||  isOnPage('amazon') || isOnPage('google') ){
      return   setProvideText("Enter T-Mobile Phone Number") ;
    } else {
      return setProvideText("Enter T-Mobile or Sprint Phone Number")
       
  }
  }
  const getCompanyLookup = companyLookupFn(
    
    () =>  setProviderNotFound(false),
    () => {
      dispatch({type: "MISCERROR", payload: {ooma: "We don't recognize that phone number, please enter a valid T-Mobile or Sprint phone number."}})
      setProviderNotFoundMessage("We don't recognize that phone number, please enter a valid T-Mobile or Sprint phone number.")
    },
    dispatch)

  const IneligibleErrorMsg = ({ errorMessage, checkStatusMode }) => {
    const style = checkStatusMode ? {color: 'white'} : {};
    return (
      <div className="ineligible-error" style={style}>{errorMessage}</div>
    )
  }

  const DefaultButton = ({ disabled }) => (
    <Button type="submit" className="btn" primary disabled={disabled}>
      Continue
    </Button>
  )

  return (
    <section ref={phoneNumberInputContainer}>               
      <Formik
        initialValues={initialValues}
        validate={values => {
          validatePhone(values.phoneNumber)
          focusOnPhoneNumber(values.phoneNumber)
        }
        }
        onSubmit={(values, actions) => getCompanyLookup(values.phoneNumber.replace(/\D+/g, ''), actions, promoCode)}>
        {({ isSubmitting, status, errors, submitForm }) => (
          <Form>
            <div className="row">
              <div className={`form-group text-center ${phoneInputClass ? phoneInputClass : "col-md-12"}`}>
                <label htmlFor={phoneNumberId}>{provideText}</label>
                <Field id={phoneNumberId} name="phoneNumber" validate={validatePhone} component={NumberInput} type="text" placeholder="" />
                {checkStatusMode && errors.phoneNumber && <p className="white">{errors.phoneNumber}</p>}
              </div>
              {providerNotFound && <IneligibleErrorMsg errorMessage={providerNotFoundMessage} checkStatusMode={checkStatusMode} />}
              {status && status.formError && <ErrorMessage>{status.formError}</ErrorMessage>}
              {miscError.length ? <div className="text-center col-md-12"><ErrorMessage>{miscError}</ErrorMessage></div> : null}
            </div>
            {buttons ?
              buttons.map((Btn, idx) => (
                <div className="mt-3 text-center" key={idx}>
                  <Btn disabled={isSubmitting} handleClick={submitForm}/>
                </div>))
              :
              <div className="mt-3 text-center">
                <DefaultButton disabled={isSubmitting}/>
              </div>}
          </Form>)}
      </Formik>
    </section>
  )
}

CrossCompanyPhoneCheck.propTypes = {
  initialValues: PropTypes.any.isRequired,
  promoCode: PropTypes.string,
  buttons: PropTypes.arrayOf(PropTypes.func),
  checkStatusMode: PropTypes.bool,
  phoneInputClass: PropTypes.string,
  fromYoutubeComponent: PropTypes.string
}
